// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1966":"0e791e1108db97a6","3899":"38bb32319b30404d"}[chunkId] + ".js";
};